import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { IngredientsServices } from '../../../ingredients/services';
import { TranslateService } from '@ngx-translate/core'
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
/**
 * Generated class for the IngredientCompPartialIngSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-providers-partial-ingredients-select',
    templateUrl: 'providers-partial-ingredients-select.html',
})
export class ProvidersPartialIngredientsSelectPage {

    term: string;
    ingredients: any;
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        private toastCtrl: ToastController,
        public ingredientsServices: IngredientsServices,
        public globals: Globals,
        public translate: TranslateService) {

        this.initIngredients();

    }

    async initIngredients() {
        this.ingredientsServices.getPagesIngredients('basic', 0);
    }

    insert(ingredient) {
        if (!this.check(ingredient.UID)) { //Buscamos si el ingrediente ya esta anadido
            var _array = Array();
            _array.push(ingredient.UID);
            _array.push(ingredient.name);
            _array.push(ingredient.allergens);
            _array.push(ingredient.providers);
            _array.push(ingredient.price_static || 0);

            this.ingredientsServices.provider_ingredients_array_tmp.push(_array);
            this.ingredientsServices.provider_ingredients_array_tmp = [...this.ingredientsServices.provider_ingredients_array_tmp];

            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-ingrediente') + ' ' + ingredient.name + ' ' + this.translate.instant('instant-anadido-correctemente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-ingrediente-esta-anadido-lista'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    check(value) {
        var response = false;
        for (var i = 0; i < this.ingredientsServices.provider_ingredients_array_tmp.length; i++) {
            var obj = this.ingredientsServices.provider_ingredients_array_tmp[i];
            if (obj[0] == value) {
                response = true;
            }
        }
        return response;
    }

    nextPage() {
        if (this.ingredientsServices.page_active < this.ingredientsServices.pagesIngredients.length) {
            this.ingredientsServices.page_active += 1
        }
        this.ingredientsServices.getListIngredientsMinMax();
    }
    previusPage() {
        if (this.ingredientsServices.page_active > 1) {
            this.ingredientsServices.page_active -= 1;
        }
        this.ingredientsServices.getListIngredientsMinMax();
    }
    activePage(number) {
        this.ingredientsServices.page_active = number;
        this.ingredientsServices.getListIngredientsMinMax();
    }
    clickElement(event) {
        if (event.type == 'click') {
            this.insert(event.row);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/providers/providers-add-select-elements/providers-partial-ingredients-select/providers-partial-ingredients-select.ts